import { render, staticRenderFns } from "./SelectPayload.vue?vue&type=template&id=062c75c6"
import script from "./SelectPayload.vue?vue&type=script&lang=js"
export * from "./SelectPayload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports